import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { getPropertyValue } from '../../tables.helper';
import { saveAs } from 'file-saver';
import { MatTableDataSource } from '@angular/material/table';

export enum TYPE_BULK_ACTIONS {
    // Acción para crear registros masivamente
    MASSIVE_CREATE = 'MASSIVE_CREATE',

    // Acción para actualizar registros masivamente
    MASSIVE_UPDATE = 'MASSIVE_UPDATE',
}

@Component({
    selector: 'app-bulk-data-upload',
    templateUrl: './bulk-data-upload.component.html',
    styleUrls: ['./bulk-data-upload.component.scss'],
})
export class BulkDataUploadComponent implements OnInit {
    @Input() uploadFunction: (file: File) => Observable<any>;
    @Input() downloadTemplateFunction: () => Observable<any>;

    public isLoading: boolean = false;
    public showBtnDownload = true;
    public isSaving: boolean = false;
    public displayedColumns = [];
    public selectedFile: File | any;
    public validRows = [];
    public invalidRows = [];
    public responseValidate: any;
    public getPropertyValue = getPropertyValue;

    public expandedRow: any | null = null;
    public columnsToDisplayValid: string[];
    public columnsToDisplayInvalid: string[];
    public dataSourceValid = new MatTableDataSource<any>([]);
    public dataSourceInvalid = new MatTableDataSource<any>([]);

    constructor(
        public dialog: MatDialogRef<BulkDataUploadComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            typeAction: TYPE_BULK_ACTIONS;
            title: string;
            displayedColumns: any[];
        },
        private toastr: ToastrService
    ) {
        this.displayedColumns = [...data.displayedColumns];
        this.columnsToDisplayValid = this.displayedColumns
            .filter((column) => column.name !== 'actions')
            .map(({ name }) => name);
        this.columnsToDisplayInvalid = [...this.displayedColumns.map(({ name }) => name)];
    }

    ngOnInit(): void {
        if (this.data.typeAction == TYPE_BULK_ACTIONS.MASSIVE_UPDATE) {
            this.showBtnDownload = false;
        }
    }

    public downloadTemplate(): void {
        this.downloadTemplateFunction().subscribe({
            next: ({ blob, filename }) => {
                saveAs(blob, filename);
            },
            error: (err) => {
                this.toastr.error(err.message);
            },
        });
    }

    public onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;

        // Verificamos que 'files' no sea null
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const validExtensions = ['.xls', '.xlsx'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

            if (!validExtensions.includes(fileExtension)) {
                this.toastr.error('Formato de archivo no válido.');
                return;
            }

            // Procesar el archivo si es válido
            this.processFile(file);

            // Limpiar el valor del input después de procesarlo
            input.value = '';
        } else {
            this.toastr.error('No se seleccionó ningún archivo.');
        }
    }

    private processFile(file: File): void {
        this.uploadFunction(file).subscribe({
            next: (response) => {
                const validateData = response.data[1].payload;
                this.responseValidate = validateData;

                // Configuración de la tabla de datos válidos
                this.dataSourceValid = new MatTableDataSource(validateData[0].valid);
                this.validRows = validateData[0].valid;

                const invalidData = validateData[0].invalid.map((item: any) => ({
                    ...item.row,
                    errors: item.errors,
                }));
                this.dataSourceInvalid = new MatTableDataSource(invalidData);
            },
            error: (err) => {
                this.toastr.error(err?.error?.error);
            },
        });
    }

    public closeDialog(): void {
        const invalidRows = this.responseValidate?.[0]?.invalid ?? [];
        this.dialog.close({
            send: false,
            rows: invalidRows,
        });
    }

    public createData(): void {
        const response = this.responseValidate?.[0];

        if (!response) {
            this.toastr.warning('No hay datos a guardar.');
            return;
        }

        const hasInvalidData = response.invalid?.length > 0;
        if (hasInvalidData) {
            this.toastr.warning('Hay datos inválidos que aún requieren atención.');
            return;
        }

        this.dialog.close({
            send: true,
            rows: response.valid ?? [],
        });
    }
}
